<template>
  <div>
    <a-page-header
      style="border: 1px solid rgb(235, 237, 240);background: #ffffff"
      title="尺寸详情"
      :breadcrumb=" { props: { routes:[{path:'/',breadcrumbName:$t('HOME')}
      ,{path:'/app-info',breadcrumbName:'小程序信息'}
      ,{path:`/appInfoDetail/${appInfoId}`,breadcrumbName:'尺寸详情'}
      ] } }"
    />
    <div style="position: relative">
      <a-menu :defaultSelectedKeys="['goods']" mode="horizontal">
        <a-menu-item
          key="goods"
          :disabled="!appInfoId"
        >
          <a-icon type="appstore"/>
          尺寸详情
        </a-menu-item>
      </a-menu>
      <a-space style="position: absolute;right: 8px;top: 8px;">
        <a-button type="primary" @click="addSizeTip">
          {{ $t('ADD') || '添加' }}
        </a-button>
        <a-button @click="onCancel">
          {{ $t('BACK') || '返回' }}
        </a-button>
      </a-space>
    </div>
    <a-spin :spinning="form.loading">
      <div style="margin: 16px">
        <a-card>
          <a-table :data-source="table.data">
            <a-table-column
              title="类型">
              <template slot-scope="text, record">
                <span>{{record.type}}</span>
              </template>
            </a-table-column>
            <a-table-column
              title="图片">
              <template slot-scope="text, record">
                <a-avatar :src="record.coverPath"/>
              </template>
            </a-table-column>
            <a-table-column
              data-index="date"
              :title="$t('OPERATION')||'操作'">
              <template slot-scope="text, record">
                <a-button type="link" @click="editSizeTip(record.id)">{{ $t('EDIT') || '编辑' }}
                </a-button>
                <a-button
                  type="link"
                  @click="deleteSizeTip(record.id)">{{ $t('DELETE') || '删除' }}
                </a-button>
              </template>
            </a-table-column>
          </a-table>
        </a-card>
      </div>
    </a-spin>
    <a-modal
      :footer="null"
      append-to-body
      :title="$t('PREVIEW')||'预览'"
      v-model="form.visible">
      <app-info-detail-edit
        v-if="form.visible"
        :app-info-id="appInfoId"
        :size-id="form.data.id"
        :on-cancel-handler="closeForm"
        :on-submit-handler="closeForm"
      />
    </a-modal>
  </div>
</template>

<script>
import {
  _querySizeTip,
  _deleteSizeTip,
} from '@/api/appInfoDetailApi';
import AppInfoDetailEdit from '@/views/cms/appInfo/AppInfoDetailEdit.vue';

async function initData() {
  let direction = this.table.sort.order;
  if (direction) {
    direction = direction === 'ascend' ? 'ASC' : 'DESC';
  }
  const result = await _querySizeTip({
    appInfoId: this.appInfoId,
    page: this.table.query.page,
    size: this.table.query.size,
    sort: this.table.sort.prop,
    direction,
  });
  this.table.data = result.content;
  this.table.query.total = result.totalElements;
}

function onCancel() {
  this.$router.go(-1);
}

function addSizeTip() {
  this.form.data.id = null;
  this.form.visible = true;
}

function editSizeTip(id) {
  console.log(id);
  this.form.data.id = id;
  this.form.visible = true;
}
function deleteSizeTip(id) {
  this.$confirm({
    title: this.$t('CONFIRM_REMOVE'),
    content: '',
    onOk: async () => {
      await _deleteSizeTip(id);
      this.$message.success(this.$t('REMOVE_SUCCESS'));
      this.initData();
    },
  });
}

function closeForm() {
  this.form.data.id = null;
  this.form.visible = false;
  this.initData();
}

export default {
  name: 'AppInfoDetailList',
  components: { AppInfoDetailEdit },
  props: {
    appInfoId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    appInfoId() {
      if (this.appInfoId) {
        this.initData();
      }
    },
  },
  methods: {
    onCancel,
    initData,
    addSizeTip,
    editSizeTip,
    deleteSizeTip,
    closeForm,
  },
  data() {
    return {
      topic: {
        data: [],
      },
      table: {
        data: [],
        query: {
          page: 1,
          size: 100,
          total: 0,
        },
        sort: {
          prop: 'sort',
          order: 'descending',
        },
      },
      form: {
        loading: false,
        visible: false,
        data: {
          id: '',
        },
        rules: {
          name: [{
            required: true,
            trigger: 'blur',
          }],
          type: [{
            required: true,
            trigger: 'blur',
          }],
          topicId: [{
            required: true,
            trigger: 'blur',
          }],
        },
        title: '',
      },
    };
  },
  async created() {
    if (this.appInfoId) {
      console.log(this.appInfoId);
      await this.initData();
    }
  },
};
</script>
